'use client'

import { CookieBanner } from '@graftcode/design-system'

import { useLayoutStore } from '../../stores/layout.store'

export function CookieBannerGuard() {
  const { isLoading } = useLayoutStore()

  if (isLoading) return null

  return <CookieBanner />
}
